import { Button, Card, Col, Empty, Form, Input, Modal, Row } from 'antd'
import React, { useCallback, useEffect, useState } from 'react'
import VideoService from '../../services/VideoService';
import _ from 'lodash';
import { IVideoRequest } from '../../types/Video';
import { openNotification } from '../../utils';

interface VideoListProps {
    setVimeoId: any;
}

const VideoList: React.FC<VideoListProps> = ({ setVimeoId }) => {
    const [isOpen, setIsOpen] = useState(false);
    const [loading, setLoading] = useState(false);
    const [searchText, setSearchText] = useState("");
    const [videoList, setVideoList] = useState<any[]>([]);
    const [filteredVideoList, setFilteredVideoList] = useState<any[]>([]);

    useEffect(() => {
        getVimeoList();
    }, [])


    const getVimeoList = () => {
        // Check if the video list exists in localStorage
        const storedVideoList = localStorage.getItem('videoList');
    
        if (storedVideoList) {
            // If video list is found in localStorage, parse and set it without making a service call
            setVideoList(JSON.parse(storedVideoList));
            return;
        }
    
        // If not found in localStorage, fetch from the service
        setLoading(true);
        VideoService.getVimeoList()
            .then((response: any) => {
                const data = response.data.data;
                setVideoList(data);
    
                // Save the fetched data to localStorage for future use
                localStorage.setItem('videoList', JSON.stringify(data));
            })
            .catch((e: Error) => {
                console.log(e);
            })
            .finally(() => {
                setLoading(false);
            });
    };

    const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value;
        setSearchText(value);

        if (value.length > 2) {
            debouncedGetVimeo(value);
        } else {
            setFilteredVideoList([]);
        }
    };

    const normalizeString = (str: string): string => {
        return str.normalize('NFD').replace(/[\u0300-\u036f]/g, "")
            .replace(/ğ/g, 'g')
            .replace(/ü/g, 'u')
            .replace(/ş/g, 's')
            .replace(/ı/g, 'i')
            .replace(/ö/g, 'o')
            .replace(/ç/g, 'c')
            .replace(/Ğ/g, 'G')
            .replace(/Ü/g, 'U')
            .replace(/Ş/g, 'S')
            .replace(/İ/g, 'I')
            .replace(/Ö/g, 'O')
            .replace(/Ç/g, 'C');
    };

    const debouncedGetVimeo = useCallback(
        _.debounce((value: string) => {
            const lowercasedValue = normalizeString(value.toLowerCase());
            console.log("Normalized arama değeri:", lowercasedValue);

            const filteredVideos = videoList.filter((video: any) => {
                const name = video.name ? normalizeString(video.name.toLowerCase()) : '';
                const description = video.description ? normalizeString(video.description.toLowerCase()) : '';

                const nameIncludes = name.includes(lowercasedValue);
                const descriptionIncludes = description.includes(lowercasedValue);

                return nameIncludes || descriptionIncludes;
            });

            console.log("Filtrelenmiş videolar:", filteredVideos);
            setFilteredVideoList(filteredVideos);
        }, 300),
        [videoList]
    );

    const select = (video: any) => {
        setVimeoId(video.uri.replace('/videos/', ''))
        setIsOpen(false);
    };

    return (
        <>
            <Button className='btn bg-saha-purple btn-hover-dark fw-700 font-color-white' onClick={() => { setIsOpen(true) }}>
                Video Ekle
            </Button>
            <Modal
                title="Video Listesi"
                open={isOpen}
                onCancel={() => { setIsOpen(false) }}
                width={800}
                footer
            >
                <Row>
                    <Col span={24}>
                        <Form>
                            <Form.Item
                                name="search"
                                rules={[
                                    {
                                        required: true,
                                        message: 'Lütfen en az 3 karakter girin',
                                        min: 3,
                                    },
                                ]}
                            >
                                <Input
                                    disabled={loading}
                                    size="large"
                                    className=' mt-12'
                                    placeholder="Video ara"
                                    value={searchText}
                                    onChange={handleSearchChange}
                                />
                            </Form.Item>
                        </Form>
                    </Col>
                    <Col span={24}>
                        <Card loading={loading} className='mt-12'>
                            <Row gutter={[24, 24]}>
                                {filteredVideoList?.map((item: any, index: number) => (
                                    <Col span={12} className='mb-24' key={index} >
                                        <Card cover={<img alt={item.name} src={item.pictures.sizes[item.pictures.sizes.length - 1].link} />}>
                                            <Row align={'middle'} justify={'space-between'}>
                                                <Col>
                                                    {item.name}
                                                </Col>
                                                <Col>
                                                    <Button onClick={() => select(item)} className='btn bg-saha-purple btn-hover-dark fw-700 font-color-white'>
                                                        Ekle
                                                    </Button>
                                                </Col>
                                            </Row>
                                        </Card>
                                    </Col>
                                ))}
                            </Row>
                            {(filteredVideoList.length == 0) && <Row justify={"center"} align={"middle"}><Empty description="Video seçmek için arama yapınız"></Empty></Row>}
                        </Card>
                    </Col>
                </Row>
            </Modal>
        </>

    )
}

export default VideoList